import { render, staticRenderFns } from "./learningAreaAdmin.vue?vue&type=template&id=1737d608&"
import script from "./learningAreaAdmin.vue?vue&type=script&lang=js&"
export * from "./learningAreaAdmin.vue?vue&type=script&lang=js&"
import style0 from "./learningAreaAdmin.vue?vue&type=style&index=0&id=1737d608&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports